import Rails from '@rails/ujs';
import * as ActiveStorage from '@rails/activestorage';
import '../controllers';
import '@hotwired/turbo-rails';
import '@core/channels';
import 'chartkick/chart.js';
import 'cropperjs';
import 'trix';

Rails.start();
ActiveStorage.start();
